import { render, staticRenderFns } from "./ActiveReservationCard.vue?vue&type=template&id=695d4c08&lang=pug&"
import script from "./ActiveReservationCard.vue?vue&type=script&lang=ts&"
export * from "./ActiveReservationCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports